"use client";

import { ModalContext } from "@/components/modals/providers";
import { ModeToggle } from "@/components/mode-toggle";
import { Separator } from "@/components/ui/separator";
import { header_links_routes } from "@/data";
import { useSession } from "next-auth/react";
import NextLink from "next/link";
import { usePathname } from "next/navigation";
import { useContext, useMemo } from "react";

export const DesktopNav = () => {
    const pathname = usePathname();
    const { data: session, status } = useSession();
    const { setShowSignInModal } = useContext(ModalContext);

    const isActive = useMemo(
        () => (path: string) => {
            return pathname === path;
        },
        [pathname],
    );

    return (
        <div className="hidden items-center space-x-4 md:flex">
            <nav className="flex space-x-6 font-medium">
                {header_links_routes.map((route, idx) => {
                    const route_path = route.path;

                    return (
                        <NextLink
                            key={`${idx}${route.path}`}
                            href={route_path}
                            className={`${isActive(route.path) && "text-primary"}`}
                        >
                            {route.label}
                        </NextLink>
                    );
                })}
            </nav>
            <Separator orientation="vertical" className="h-8" />
            <div className="flex items-center space-x-3">
                <ModeToggle />
            </div>
        </div>
    );
};
